import React from "react";
import { BackButtonHeader } from "./back-button";
import { Link } from "react-router-dom";
import { Img } from "../../components/shared/img";
import { Icon } from "@iconify/react";
import { useTranslations } from "../../hooks/use-translations";
import { Helmet } from "react-helmet";
import { useLanguage } from "../../hooks/use-language";
import { useId } from "../../hooks/use-id";

/**
 * Este componente muestra la pantalla No encuentro mi instituto
 * Su principal función es redireccionar a las pantallas de ayudanos a contactar a tu institución y agendar una cita
 */

export const InstitutionNotFound = () => {
	const lang = useLanguage();
	const textos = useTranslations({ section: "autenticacion_institucional", lang: lang });
	const optionsTitle = useId('options-title');

	return (
		<div className="institutional-auth">
			<Helmet>
                <title>{textos?.metadata?.no_found?.title || 'MakeMake - Buscar una institución'}</title>
                <meta name="description" content={textos?.metadata?.no_found?.description || 'Busca tu institución para ingresar a MakeMake y disfruta tu colección.'} />
            </Helmet>
			<div className="relative">
				<div className="bg-shape"></div>
				<section aria-labelledby={optionsTitle} className="container page-content d-flex flex-column align-items-center w-100 h-100">
					<BackButtonHeader link={"/"} />
					<h1 className="onsecondary-title mt-5" id={optionsTitle}>
						{textos?.institucion_no_encontrada?.titulo || "No encuentro mi institución"}
					</h1>
					<h2 className="onsecondary-title2 mb-4 mt-3">
						{textos?.institucion_no_encontrada?.descripcion ||
							"MakeMake tiene alternativas para ti"}
					</h2>
					<div className="row justify-content-center">
						<OptionCard
							img={"/img/institutional-auth/cita.png"}
							description={
								textos?.institucion_no_encontrada?.tarjeta?.cita?.descripcion ||
								"Podemos conocernos para saber qué necesitas y como te ayudamos"
							}
						>
							<div>
								<Link
									to={"/tienda/institucional"}
									className="inline-flex primary-button-var2 focusable-red"
								>
									{textos?.institucion_no_encontrada?.boton?.cita ||
										"Agendar una cita"}
								</Link>
							</div>
						</OptionCard>
						<OptionCard
							img={"/img/institutional-auth/plan-individual.png"}
							description={
								textos?.institucion_no_encontrada?.tarjeta?.comprar_plan
									?.descripcion || "¡Accede a las lecturas desde tu casa!"
							}
						>
							<div>
								<Link
									to={"/tienda/plan-casa"}
									className="inline-flex primary-button-var2 focusable-red"
								>
									{textos?.institucion_no_encontrada?.boton?.comprar_plan ||
										"Compra un plan para ti"}
								</Link>
							</div>
						</OptionCard>
						<OptionCard
							img={"/img/institutional-auth/contacto.png"}
							description={
								textos?.institucion_no_encontrada?.tarjeta?.contacto?.descripcion ||
								"Contáctanos para poderte ayudar"
							}
						>
							<div className="d-flex flex-column">
								<a
									href={"mailto:comercial@makemake.com.co"}
									target="_blank"
									rel="noopener noreferrer"
									className="d-flex align-items-center text-break secondary-var2-link mb-2 focusable-red"
									style={{ textDecoration: "none" }}
								>
									<Icon icon="ic:baseline-email" width={22} className="mr-2" />{" "}
									comercial@makemake.com.co
								</a>
								<a
									href={"https://wa.link/aozzbk"}
									target="_blank"
									rel="noopener noreferrer"
									className="d-flex align-items-center text-break secondary-var2-link focusable-red"
									style={{ textDecoration: "none" }}
								>
									<Icon icon="dashicons:whatsapp" width={22} className="mr-2" />{" "}
									+57 350 2367037
								</a>
							</div>
						</OptionCard>
					</div>
				</section>
			</div>
		</div>
	);
};

const OptionCard = ({ img, description, children }) => {
	return (
		<article className="m-2 col-12 col-sm-10 col-md-9 col-lg-5 col-xl d-flex flex-column align-items-center justify-content-center">
			<div className="not-found-option-card d-flex flex-column px-3 py-5 w-100 h-100 justify-content-between align-items-center">
				<div className="justify-content-center img-wrapper mb-4 mt-4">
					<Img className="w-100 h-100" src={img} alt="" aria-hidden={true} />
				</div>
				<p className="description mb-4 text-center px-3">{description}</p>
				<div className="">{children}</div>
			</div>
		</article>
	);
};
